import Enum from '../interfaces/IEnum';

export const GraphicType: Enum = {
    enum: {
        CANDIDATE : 0,
        PROCESS: 1
    }
};
